
export const SEGMENTO_OPTIONS = [
  { label: 'Agência / Consultoria', value: 'Agência / Consultoria' },
  { label: 'Agronegócio', value: 'Agronegócio' },
  { label: 'Autoconhecimento', value: 'Autoconhecimento' },
  { label: 'Automotiva', value: 'Automotiva' },
  { label: 'Bens de Consumo / Alimentos', value: 'Bens de Consumo / Alimentos' },
  { label: 'E-commerce', value: 'E-commerce' },
  { label: 'Educação', value: 'Educação' },
  { label: 'Empresa pública / ONGs', value: 'Empresa pública / ONGs' },
  { label: 'Energia', value: 'Energia' },
  { label: 'Eventos', value: 'Eventos' },
  { label: 'Financeiro', value: 'Financeiro' },
  { label: 'Imobiliário', value: 'Imobiliário' },
  { label: 'Indústria', value: 'Indústria' },
  { label: 'Infoprodutos', value: 'Infoprodutos' },
  { label: 'Mídia comunicação', value: 'Mídia comunicação' },
  { label: 'Mobilidade', value: 'Mobilidade' },
  { label: 'Moda / Vestuário', value: 'Moda / Vestuário' },
  { label: 'Religião / Espiritualidade', value: 'Religião / Espiritualidade' },
  { label: 'Saúde / Beleza / Bem-Estar', value: 'Saúde / Beleza / Bem-Estar' },
  { label: 'Serviços gerais', value: 'Serviços gerais' },
  { label: 'Tecnologia / SaaS', value: 'Tecnologia / SaaS' },
  { label: 'Telecomunicações', value: 'Telecomunicações' },
  { label: 'Transporte / Logística', value: 'Transporte / Logística' },
  { label: 'Turismo / Lazer', value: 'Turismo / Lazer' },
  { label: 'Varejo', value: 'Varejo' },
  { label: 'Outro', value: 'Outro' },
];

export const CARGO_OPTIONS = [
  { label: 'CEO', value: 'CEO' },
  { label: 'Fundador', value: 'Fundador' },
  { label: 'Presidente', value: 'Presidente' },
  { label: 'Diretor', value: 'Diretor' },
  { label: 'Gerente', value: 'Gerente' },
  { label: 'Coordenador', value: 'Coordenador' },
  { label: 'Analista', value: 'Analista' },
  { label: 'Consultor', value: 'Consultor' },
  { label: 'Autônomo', value: 'Autônomo' },
  { label: 'Supervisor', value: 'Supervisor' },
  { label: 'Assessor', value: 'Assessor' },
  { label: 'Assistente', value: 'Assistente' },
  { label: 'Estagiário', value: 'Estagiário' },
  { label: 'Estudante', value: 'Estudante' },
  { label: 'Professor', value: 'Professor' },
];

export const FUNCIONARIOS_OPTIONS = [
  { label: '1 - 10', value: '1 - 10' },
  { label: '11 - 20', value: '11 - 20' },
  { label: '21 - 50', value: '21 - 50' },
  { label: '51 - 100', value: '51 - 100' },
  { label: '101 - 200', value: '101 - 200' },
  { label: '201 - 500', value: '201 - 500' },
  { label: '501 - 1.000', value: '501 - 1.000' },
  { label: '1.001 - 5.000', value: '1.001 - 5.000' },
  { label: 'Acima de 5.000', value: 'Acima de 5.000' },
];

export const AREA_ATUACAO_OPTIONS = [
  { label: 'Administrativo', value: 'Administrativo' },
  { label: 'Comercial', value: 'Comercial' },
  { label: 'Contábil', value: 'Contábil' },
  { label: 'Customer Success', value: 'Customer Success' },
  { label: 'E-commerce', value: 'E-commerce' },
  { label: 'Financeiro', value: 'Financeiro' },
  { label: 'Marketing', value: 'Marketing' },
  { label: 'Operação', value: 'Operação' },
  { label: 'RH', value: 'RH' },
  { label: 'SEO', value: 'SEO' },
  { label: 'Tecnologia', value: 'Tecnologia' },
  { label: 'Outra área', value: 'Outra área' },
];
